import React, { useEffect, useState } from "react";
import api from '../api/axiosInstance';
import {Button} from "../components/Button";

export default function AdminHolidayManager() {
    const [holidays, setHolidays] = useState([]);
    const [form, setForm] = useState({ name: "", date: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchHolidays();
    }, []);

    async function fetchHolidays() {
        try {
            setLoading(true);
            const res = await api.get("/admin/holiday/holidays");
            setHolidays(res.data);
            setError(null);
        } catch (err) {
            console.error(err);
            setError("Failed to load holidays");
        } finally {
            setLoading(false);
        }
    }

    async function addHoliday(e) {
        e.preventDefault();
        if (!form.name || !form.date) return;

        try {
            await api.post("/admin/holiday/addHoliday", form);
            await fetchHolidays();
            setForm({ name: "", date: "" });
        } catch (err) {
            console.error(err);
            setError("Failed to add holiday");
        }
    }

    const handleRefreshHolidayCache = async () => {
        try {
            await api.post('/admin/executescripts/refresh-holidays');
        } catch (err) {
            console.error(err);
            alert(err.response?.data?.error || "Holiday cache failed. Check console for details.");
        }
    };

    async function deleteHoliday(name, date) {
        try {
            await api.delete("/admin/holiday/delete", {
                data: { name, date },
            });
            setHolidays((prev) =>
                prev.filter(
                    (h) => !(h.name === name && new Date(h.date).toISOString() === new Date(date).toISOString())
                )
            );
        } catch (err) {
            console.error(err);
            setError("Failed to delete holiday");
        }
    }

    return (
        <div className="p-6 max-w-2xl mx-auto">
            <h1 className="text-2xl font-bold mb-4">Holiday Management</h1>


            <Button onClick={handleRefreshHolidayCache} className="bg-yellow-500 hover:bg-yellow-600 mb-4">
                Refresh Holidays
            </Button>

            <form onSubmit={addHoliday} className="mb-6 flex flex-col gap-3">
                <input
                    type="text"
                    placeholder="Holiday Name"
                    value={form.name}
                    onChange={(e) => setForm({ ...form, name: e.target.value })}
                    className="border rounded p-2"
                    required
                />
                <input
                    type="date"
                    value={form.date.split("T")[0]}
                    onChange={(e) => setForm({ ...form, date: e.target.value })}
                    className="border rounded p-2"
                    required
                />
                <Button
                    type="submit"
                >
                    Add Holiday
                </Button>
            </form>

            {loading && <p>Loading holidays...</p>}
            {error && <p className="text-red-500">{error}</p>}

            <table className="w-full border border-gray-300">
                <thead className="bg-gray-100">
                <tr>
                    <th className="border p-2 text-left">Name</th>
                    <th className="border p-2 text-left">Date (YYYY-MM-DD)</th>
                    <th className="border p-2">Action</th>
                </tr>
                </thead>
                <tbody>
                {holidays.map((h, i) => (
                    <tr key={i} className="border-t">
                        <td className="p-2">{h.name}</td>
                        <td className="p-2">{h.date}</td>
                        <td className="p-2 text-center">
                            <button
                                onClick={() => deleteHoliday(h.name, h.date)}
                                className="text-red-600 hover:underline"
                            >
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
                {holidays.length === 0 && !loading && (
                    <tr>
                        <td colSpan="3" className="text-center p-4 text-gray-500">
                            No holidays found
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
}
